import {
  mapGetters,
} from 'vuex';
import Multiselect from 'vue-multiselect';

import {
  DEFAULT_IMAGE,
} from '@/utils/const';

import Api from '@/utils/api';

export default {
  components: {
    Multiselect,
  },
  props: {
    index: {
      type: Number,
      default: 0,
    },
    document: {
      type: Object,
      default: () => {},
    },
    errorCategoryList: {
      type: Array,
      default: () => [],
    },
    TextCategoryList: {
      type: Array,
      default: () => [],
    },
    langList: {
      type: Array,
      default: () => [],
    },
    accessList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      defaultImage: DEFAULT_IMAGE,

      clientList: [{
        ID: 1,
        Name: 'TEST_1',
      }, {
        ID: 2,
        Name: 'TEST_2',
      }, {
        ID: 3,
        Name: 'TEST_3',
      }],
      validateForm: false,
    };
  },
  computed: {
    ...mapGetters({
      user: 'user',
    }),
  },
  created() {
    this.getTextCategories();
  },
  methods: {
    getTextCategories() {
      Api.textCategory
        .get()
        .then((res) => {
          if (res.status === 200) {
            this.TextCategoryList = res.data.map((el) => el);
          }
        }).catch((err) => {
          this.$root.$emit('notification', {
            message: err,
            type: 'error',
            show: true,
          });
        });
    },
    confirmRemove(idx) {
      this.$modal.show('dialog', {
        title: 'Confirm Delete',
        text: 'Do you want to delete this document from upload list?',
        buttons: [{
          title: 'Yes',
          handler: () => {
            this.removeDoc(idx);
            this.$modal.hide('dialog');
          },
        }, {
          title: 'No',
        }],
      });
    },
    removeDoc(name) {
      this.$emit('removeDoc', name);
    },
    validate(e) {

    },
    /**
     * Limit text for multiselect
     *
     * @param {NUmber} count
     */
    limitText(count) {
      return `and ${count} others`;
    },
  },
};
